import { render, staticRenderFns } from "./BooleanInputTable.vue?vue&type=template&id=3dbe0246&scoped=true&"
import script from "./BooleanInputTable.vue?vue&type=script&lang=js&"
export * from "./BooleanInputTable.vue?vue&type=script&lang=js&"
import style0 from "./BooleanInputTable.vue?vue&type=style&index=0&id=3dbe0246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe0246",
  null
  
)

export default component.exports